import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AccountService } from '../common/account.service';
import { AlertService } from '../common/alert.service';


@Component({
  selector: 'app-change-other-user-password',
  templateUrl: './change-other-user-password.component.html',
  styleUrls: ['./change-other-user-password.component.css']
})
export class ChangeOtherUserPasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;

  constructor(
      private formBuilder: FormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      private accountService: AccountService,
      private alertService: AlertService
  ) {
      // redirect to home if already logged in
      // if (this.accountService.isUserLoggedIn()) {
      //     this.router.navigate(['oddsee/tournaments']);
      // }
  }

  ngOnInit() {
      this.changePasswordForm = this.formBuilder.group({
        login: ['', Validators.required],
        newPassword: ['', Validators.required],
      });

      // get return url from route parameters or default to '/'
      // this.returnUrl = this.route.snapshot.queryParams[''] || 'oddsee/tournaments';
  }

  // convenience getter for easy access to form fields
  get f() { return this.changePasswordForm.controls; }

  onSubmit() {
      this.submitted = true;

      // reset alerts on submit
      this.alertService.clear();

      // stop here if form is invalid
      if (this.changePasswordForm.invalid) {
          return;
      }

      this.loading = true;
      this.accountService.resetPassword(this.f.login.value, this.f.newPassword.value)
          .then(
              () => {
                    this.router.navigateByUrl('',{skipLocationChange:true});
              },
              error => {
                  this.alertService.error(error);
                  this.loading = false;
              });    
  }
}

